import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import GroceryList from './presenter';
import Types from 'Types';
import { selectGroceries } from 'src/state/recipe/selectors';
import { withRouter } from 'react-router-dom';

interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
  groceries: selectGroceries(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(GroceryList));